import { render, staticRenderFns } from "./UserReferralsDialog.vue?vue&type=template&id=60556069&scoped=true"
import script from "./UserReferralsDialog.vue?vue&type=script&lang=ts"
export * from "./UserReferralsDialog.vue?vue&type=script&lang=ts"
import style0 from "./UserReferralsDialog.vue?vue&type=style&index=0&id=60556069&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60556069",
  null
  
)

export default component.exports